/**
 * Main JS Libraries
 */
import 'bootstrap-sass';
window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
require('vue');
require('chartkick');
require('vue-chartkick');
require('chart.js');

// IE polyfill:
require('es6-promise/auto');
require('console-polyfill');



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js